<script lang="ts">
	import { page } from '$app/stores';
	import QRCode from '@castlenine/svelte-qrcode';
	import logoMinimalImg from '@lib/images/logo/brand-minimal.svg';
	import type { AppDownloadLink } from '@lib/types';
	import { onMount } from 'svelte';
	import { getAppDownloadLinks } from '@lib/utils';
	import Spinner from '../micro/Spinner.svelte';

	let appDownloadLinksPromise: Promise<AppDownloadLink[] | undefined>;

	onMount(() => {
		appDownloadLinksPromise = getAppDownloadLinks();
	});
</script>

<div class="download-panel">
	{#await appDownloadLinksPromise}
		<div class="grid min-h-44 w-72 place-items-center">
			<Spinner class="size-10" />
			<span class="sr-only">Harap tunggu sesaat...</span>
		</div>
	{:then appDownloadLinks}
		<div class="min-h-44 w-72">
			{#if appDownloadLinks}
				<p class="mb-4 text-balance text-center text-sm font-medium text-neutral">
					Scan QR atau Download di
				</p>
				<div class="grid grid-cols-2 items-center gap-5">
					<div>
						<QRCode
							isJoin
							isResponsive
							logoPath={logoMinimalImg}
							logoSize={18}
							data="{$page.url.origin}/get-download-app-link"
						/>
					</div>
					<div class="grid gap-2">
						{#each appDownloadLinks as provider}
							<a
								target="_blank"
								rel="noreferrer noopener"
								class="block w-full"
								href={provider.url}
								aria-label="{provider.label}'s link"
							>
								<img class="h-auto w-36" src={provider.icon} alt={provider.label} />
							</a>
						{/each}
					</div>
				</div>
			{/if}
		</div>
	{:catch _}
		<p>Terjadi kesalahan, silahkan refresh halaman</p>
	{/await}
</div>
